import { RepState } from "./types";
import { User } from "@/models/user_schema";



export const setRep = (state: RepState, value: User[]) => {
  state.rep = value;
};

export const setSelected = (state: RepState, value: User) => {
  state.selected = value;
};

